export { default as HomePageCollection } from './HomePageCollection'
